import React, { useContext, useEffect, useState } from 'react'
import { LoginContext, SideNavContext } from '../reactcontext/ReactContext'
import { Route, Routes, useNavigate } from 'react-router-dom'
import { LogoAndName, SideNavbar, TopNavbar } from '../components'
import { NotFound, Dashboard, VisaLanding, PassportLanding, MedicalLanding, ProfileLanding, AgentLanding, PaymentLanding, ReportLanding, UserLanding, Support} from '.'
import NeedMC from './passport/NeedMC'
import ProfileAdd from '../components/ProfileAdd'
import AgentProfile from './agent/AgentProfile'
import ExpiredPassports from './reports/passport/ExpiredPassports'
import DueToExpire from './reports/passport/DueToExpire'
import ExpiredVisa from './reports/visa/ExpiredVisa'
import DueToExpireV from './reports/visa/DueToExpire'
import AgentWithProfiles from './reports/payments/AgentWithProfiles'
import Balances from './reports/payments/Balances'
import Collection from './reports/payments/Collection'
import MyProfile from './user/MyProfile'
import RecordPayment from './Payment/RecordPayment'
import UpdatePayment from './Payment/UpdatePayment'
import Invoice from './Payment/Invoice'
import VisaExpire from './Payment/VisaExpire'

const Landing = () => {
  const { loginInfo } = useContext(LoginContext)
  const navigate = useNavigate()
  const [toggleMenu, setToggleMenu] = useState(true)

  // useEffect(() => {
  //   if(!loginInfo.login){
  //       navigate('/')
  //   }
  // }, [loginInfo])

  return (
    <SideNavContext.Provider value={{toggleMenu, setToggleMenu}}>
      <div className='md:hidden flex py-[4px]'>
        <LogoAndName />
      </div>
      <div className='w-full h-full flex flex-row p-[1px] bg-dimWhite flex-1 overflow-hidden'>

        {/* side navbar */}
        {
          toggleMenu && <SideNavbar />
        }
        
        
        {/* main container */}
        <div className='flex-1 min-w-0 h-full bg-white flex flex-col'>
          
          {/* top nav */}
          <TopNavbar 
            navigate={navigate}
          />

          <div className='w-full h-full overflow-auto relative'>
           <Routes>
            <Route path='/users' element={<UserLanding/>} /> 
            <Route path='/support' element={<Support/>} />
            <Route path='/my-profile' element={<MyProfile/>} />
            <Route path='/reports/Balances' element={<Balances/>} />
            <Route path='/reports/Collection' element={<Collection/>} />
            <Route path='/reports/Agent with Profiles' element={<AgentWithProfiles/>} /> 
            <Route path='/reports/Visa Due to Expire' element={<DueToExpireV/>} /> 
            <Route path='/reports/Expired Visas' element={<ExpiredVisa/>} /> 
            <Route path='/reports/Passports Due to Expire' element={<DueToExpire/>} />  
            <Route path='/reports/expired passports' element={<ExpiredPassports/>} />
            <Route path='/reports' element={<ReportLanding/>} />
            <Route path='/passport_exp' element={<PassportLanding/>} />
            <Route path='/1_month' element={<PassportLanding/>} />
            <Route path='/3_month' element={<PassportLanding/>} />
            <Route path='/6_month' element={<PassportLanding/>} />
            <Route path='/pass_expired' element={<PassportLanding/>} />
            <Route path='/passport_medical' element={<MedicalLanding/>} />
            <Route path='/medical' element={<MedicalLanding/>} />
            <Route path='/medical/need-mc' element={<NeedMC/>} />
            <Route path='/visa_exp' element={<VisaLanding/>} />
            <Route path='/30_days' element={<VisaLanding/>} />
            <Route path='/60_days' element={<VisaLanding/>} />
            <Route path='/90_days' element={<VisaLanding/>} />
            <Route path='/expired' element={<VisaLanding/>} />
            <Route path='/agents' element={<AgentLanding/>} />
            <Route path='/add_profile' element={<ProfileAdd/>} />
            <Route path='/agentProfile' element={<AgentProfile/>} />
            <Route path='/payments' element={<PaymentLanding/>} />
            <Route path='/payments/update' element={<UpdatePayment/>} />
            <Route path='/payments/record' element={<RecordPayment/>} />
            <Route path='/payments/invoice' element={<Invoice/>} />
            <Route path='/payments/visaExpire' element={<VisaExpire/>} />
            <Route path='/profile' element={<ProfileLanding/>} />
            <Route path='/dashboard' element={<Dashboard />} />
            <Route path='*' element={<NotFound/>}/>
           </Routes>
          </div>
        </div>

      </div>
    </SideNavContext.Provider>
  )
}

export default Landing
